import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InputField from 'components/InputField/InputField';
import SelectField from 'components/InputField/SelectField';
import FileField from 'components/InputField/FileField'
import NewQuiz from 'components/Admin/Quiz/NewQuiz';
import DateTimeField from 'components/InputField/DateTimeField';
import AdminCountyTagSelect from 'containers/Input/AdminCountyTagSelect';
import AdminUserTypeSelect from 'containers/Input/AdminUserTypeSelect';
import constants from 'constants';
import _ from 'lodash';
import { select } from 'redux-saga/effects';
import DisciplineTagSelect from 'containers/Input/DisciplineTagSelect.jsx';
import AdminUsersSelect from 'containers/Input/AdminUsersSelect.jsx';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormLabel, FormControl, FormControlLabel } from 'material-ui/Form';

const {
  CPD_STATUSES
} = constants;

const labels = {
  webinar_title: 'Webinar topic',
  expert_name: 'Expert name',
  work_location: 'Expert work location',
  number_cpd_points: 'Number of CPD points',
  vimeo_url: 'Vimeo video uid',
  zoom_uid: 'Zoom webinar id',
  doctor_type: 'Expert type',
  status: 'Status',
  cpd_points: 'Type of CPD points',
  cpd_status: 'CPD status',
  doctor_avatar: 'Expert avatar',
  sponsor_id: 'Sponsor',
  int_cpd_points: 'Number of Int CPD points',
  ext_cpd_points: 'Number of Ext CPD points',
  icgp_ref: 'ICGP Ref #',
  job_code_home_page: 'Job code home page',
  job_code_dashboard: 'Job code dashboard',
  job_code_recorded_list: 'Job code recorded list',
  job_code_recorded_opened: 'Job code recorded open',
  job_code_email_hour: 'Job code email hour',
  job_code_email_day: 'Job code email day'
}

const statuses = [
  { value: 'published', label: 'Published' },
  { value: 'unpublished', label: 'Unpublished' }
];

const cpdPoints = [
  { value: 'external', label: 'External' },
  { value: 'internal', label: 'Internal' },
  { value: 'both', label: 'Both' }
];

const cpdStatus = [
  { value: CPD_STATUSES.granted, label: 'Granted' },
  { value: CPD_STATUSES.applied_for, label: 'Applied for' },
  { value: CPD_STATUSES.not_applicable, label: 'Not applicable' }
];

const onlyConsultantAndOrNCHD = [3, 4]

const hideMore = (roles, counties, onConsultantOrHD) => {
  let matches = _.intersection(roles, onlyConsultantAndOrNCHD);
  if (roles && roles.length && roles.length === matches.length) {
    const selectedCounties = counties.map(county => county.value);
    onConsultantOrHD(selectedCounties);
    return true
  } else {
    return false
  }
}

const showFieldsByWebinarType = (webinar_type) => {
  if (webinar_type === 'recorded'){
    return ['doctor_type','work_location','vimeo_url' ]
  }
  return ['doctor_type','work_location','vimeo_url', 'zoom_uid' ]
}

const NewWebinarForm = ({
  webinar = {},
  errors = {},
  onFieldChange,
  onQuizAdd,
  onQuizChange,
  onQuizRemove,
  onDateChange,
  onSubmit,
  cpdPointsFields,
  onCpdPointsChange,
  onCountiesChange,
  onUserTypeChange,
  onDisciplinesChange,
  onAssignedUsersChange,
  onCpdTypeChange,
  sponsorsOptions,
  counties,
  onConsultantOrHD,
  onWebinarTypeChange
}) => {
  const hideMoreValue = hideMore(webinar.user_types, counties, onConsultantOrHD);
  return (
    <div className="container_records">
      <div className="add_webinar new-webinar">
        <h3>Add webinar</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">

            <FormControl>
              <RadioGroup
                aria-label="webinar type"
                value={webinar.webinar_type || 'online'}
                onChange={onWebinarTypeChange}
                row
              >
                <FormControlLabel
                  value="online"
                  control={<Radio color="primary"/>}
                  label="Webinar"
                />
                <FormControlLabel
                  value="recorded"
                  control={<Radio color="primary"/>}
                  label="Recorded only"
                />
              </RadioGroup>
            </FormControl>

            <AdminUserTypeSelect
              className='col s12'
              onChange={onUserTypeChange}
              value={webinar.user_types}
              errors={errors.user_types}
            />

            {hideMoreValue ? null :
              <AdminCountyTagSelect
                className='col s12'
                value={webinar.counties.map(county => (
                  { label: county, value: county }
                ))}
                onChange={onCountiesChange}
                errors={errors.counties}
              />
            }

            <DisciplineTagSelect
              className='col s12'
              onChange={onDisciplinesChange}
              value={webinar.disciplines}
              errors={errors.disciplines}
            />

            <AdminUsersSelect
              className='col s12'
              onChange={onAssignedUsersChange}
              value={webinar.assignedUsers}
              errors={errors.assignedUsers}
            />

            {
              [
                'webinar_title',
                'expert_name',
                'job_code_home_page',
                'job_code_dashboard',
                'job_code_recorded_list',
                'job_code_recorded_opened',
                'job_code_email_hour',
                'job_code_email_day'
              ].map(e => (
                <InputField
                  className='col s12'
                  label={labels[e]}
                  field_name={e}
                  onChange={onFieldChange}
                  errors={errors[e]}
                  autoComplete='new-password'
                  value={webinar[e]}
                />
              ))
            }

            <FileField
              className='col s12'
              field_name="doctor_avatar"
              onChange={onFieldChange}
              label={labels['doctor_avatar']}
              errors={errors['doctor_avatar']}
            />

            { showFieldsByWebinarType(webinar.webinar_type).map(e => (
                <InputField
                  className='col s12'
                  label={labels[e]}
                  field_name={e}
                  onChange={onFieldChange}
                  errors={errors[e]}
                  autoComplete='new-password'
                  value={webinar[e]}
                />
              ))
            }

            {hideMoreValue ? null :
            <SelectField
              className='col s12'
              label={labels['cpd_status']}
              onChange={onCpdTypeChange}
              errors={errors['cpd_status']}
              autoComplete='new-password'
              field_name='cpd_status'
              value={webinar.cpd_status}
              options={cpdStatus}
            />}
            {!hideMoreValue && webinar.cpd_status === CPD_STATUSES.granted && <InputField
              className='col s12'
              label={labels['icgp_ref']}
              field_name={'icgp_ref'}
              onChange={onFieldChange}
              errors={errors['icgp_ref']}
              autoComplete='new-password'
              value={webinar['icgp_ref']}
            />}
            {!hideMoreValue && webinar.cpd_status === CPD_STATUSES.granted && <SelectField
              className='col s12'
              label={labels['cpd_points']}
              onChange={onCpdPointsChange}
              errors={errors['cpd_points']}
              autoComplete='new-password'
              field_name='cpd_points'
              value={webinar.cpd_points}
              options={cpdPoints}
            />}

            {!hideMoreValue && cpdPointsFields.map(field =>
              <InputField
                className='col s12'
                label={labels[field]}
                field_name={field}
                onChange={onCpdPointsChange}
                errors={errors[field]}
                autoComplete='new-password'
                value={webinar[field]}
              />
            )}

            {webinar.webinar_type === 'online' &&
              <DateTimeField
                className='col s12'
                onChange={onDateChange}
                value={webinar.start_date}
                label="Start date"
                field_name='start_date'
                errors={errors['start_date']}
              />
            }
            {webinar.webinar_type === 'online' &&
              <DateTimeField
                className='col s12'
                onChange={onDateChange}
                value={webinar.end_date}
                label="End date"
                field_name='end_date'
                errors={errors['end_date']}
              />
            }

            <SelectField
              className='col s12'
              label={labels['sponsor_id']}
              onChange={onFieldChange}
              errors={errors['sponsor_id']}
              autoComplete='new-password'
              field_name='sponsor_id'
              value={webinar.sponsor_id}
              options={sponsorsOptions}
            />
            <a className={`${!webinar.sponsor_id && 'hide'}`}
              href="javascript:void(0)"
              onClick={() => { onFieldChange( {target: {name: 'sponsor_id', value: ''}} ) }}
            >
              Clear
            </a>


            <SelectField
              className='col s12'
              label={labels['status']}
              onChange={onFieldChange}
              errors={errors['status']}
              autoComplete='new-password'
              field_name='status'
              value={webinar.status}
              options={statuses}
            />

           <button onClick={onSubmit} className="button_classic" type="button" name="button"> Save</button>
          </form>
        </div>
      </div>
      {hideMoreValue ? null :
        <NewQuiz
          onChange={onQuizChange}
          onAddElement={onQuizAdd}
          onRemoveElement={onQuizRemove}
          quizzes={webinar.spd_quizzes_attributes}
        />
      }
    </div>
  );
}

NewWebinarForm.defaultProps = {};

NewWebinarForm.propTypes = {
  webinar: PropTypes.obj,
  errors: PropTypes.obj,
  onFieldChange: PropTypes.func,
  onQuizAdd: PropTypes.func,
  onQuizChange: PropTypes.func,
  onDateChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onQuizRemove: PropTypes.func,
  cpdPointsFields: PropTypes.arr,
  counties: PropTypes.array,
  onWebinarTypeChange: PropTypes.func
};

const mapStateToProps = (state) => ({
  counties: state.suggestions.county.values
})

export default connect(mapStateToProps)(NewWebinarForm);



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Webinar/NewWebinarForm.jsx
 **/